import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ApiResponse } from '../../models/common/api-response.model';
import { UpdateUserRequest, User } from '../../models/user/user.model';
import { BaseApiService } from '../common/base-api.service';

@Injectable({
  providedIn: 'root',
})
export class UserService extends BaseApiService {
  /**
   * Get current user information
   */
  getCurrentUser(): Observable<User> {
    const url = `${environment.apiUrl}/api/bot/users/me`;
    console.log('[ACFE] UserService.getCurrentUser: requesting', url);
    return this.http.get<ApiResponse<User>>(url).pipe(
      take(1),
      map((response) => response.data),
    );
  }

  /**
   * Update current user information
   */
  updateCurrentUser(data: UpdateUserRequest): Observable<User> {
    return this.http.patch<ApiResponse<User>>(`${environment.apiUrl}/api/bot/users/me`, data).pipe(
      take(1),
      map((response) => response.data),
    );
  }
}
